import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M22 12s-3 6-10 6-10-6-10-6 3-6 10-6 10 6 10 6Z",
      stroke: "black",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "3",
      stroke: "black",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }